import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PaliersObjectToCapitalDuree } from '../../engine/Rules'
import store from '../../engine/store'
import './Bloc.css'

class BlocRenegoAffichage extends Component {
    constructor(props) {
        super(props)
        this.modifierPret = this.modifierPret.bind(this)
    }

    modifierPret() {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_credit_renego_target_new', value: false },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_credit_renego_target', value: this.props.id },
        })
        history.push('/tunnelmobile/', { targetView: 26 })
    }
    supprimerPret() {
        store.dispatch({
            type: 'SET_MULTI',
            value: { key: 'credit_renego_list', value: this.props.id },
        })
    }
    render() {
        var type =
            this.props.cred_type === 'ptz'
                ? 'Prêt à Taux Zéro'
                : 'Prêt Bancaire'
        var cred_preteur = this.props.cred_preteur
            ? this.props.cred_preteur
            : 'Inconnu'
        var resultatPaliers = PaliersObjectToCapitalDuree(
            this.props.cred_paliers
        )

        //TODO AFFICHAGE MENSUALIT2 / DUREE
        return (
            <div>
                <div className="Bloc fade-in bloc-full">
                    <div className="infoBulleContainer">
                        <img
                            src="svg/delete.svg"
                            alt="remove"
                            onClick={() => this.supprimerPret()}
                        ></img>
                    </div>
                    <div className="renegoLine1 size18 bold-font"> {type} </div>
                    <div className="renegoLine2 size22 bold-font">
                        {this.props.cred_capital
                            ? this.props.cred_capital + ' €'
                            : 'Non Renseigné'}{' '}
                    </div>
                    <div className="renegoLine3 size14 transparent">
                        {' '}
                        Capital restant dû{' '}
                    </div>
                    <div className="renegoLine4 size22 bold-font">
                        {' '}
                        {cred_preteur}{' '}
                    </div>
                    <div className="renegoLine5 size14 transparent">
                        {' '}
                        Prêteur{' '}
                    </div>
                    <div className="renegoLine6 size22 bold-font">
                        {' '}
                        {resultatPaliers.mensualite} € / mois{' '}
                    </div>
                    <div className="renegoLine7 size14 transparent">
                        Mensualité moyenne avec assurance
                    </div>
                    <div className="renegoLine8 size22 bold-font">
                        {' '}
                        {resultatPaliers.duree} mois{' '}
                    </div>
                    <div className="renegoLine9 size14 transparent">
                        {' '}
                        Durée restante{' '}
                    </div>
                    <div
                        className="renegoButton"
                        onClick={() => this.modifierPret()}
                    >
                        {' '}
                        Modifier ce prêt
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    if (ownProps.id) {
        const varNameType = 'credit_renego_type_' + ownProps.id
        const varnameCapital = 'credit_renego_capital_' + ownProps.id
        const varNamePreteur = 'credit_renego_preteur_' + ownProps.id
        const varNamePalier = 'credit_renego_paliers_' + ownProps.id
        return {
            cred_type: state.answer[varNameType],
            cred_preteur: state.answer[varNamePreteur],
            cred_paliers: state.answer[varNamePalier],
            cred_capital: state.answer[varnameCapital],
        }
    }
    return {}
}

export default connect(mapStateToProps)(BlocRenegoAffichage)
